<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="heading">
        Top Devices
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/reporting"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove()"
        >
          Delete
        </button>
      </div>
    </div>
    <apexchart
      v-if="!loading && !error"
      :options="chartOptions"
      :series="series"
      height="300"
      type="bar"
    />

    <div
      v-if="loading"
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>

    <div
      v-if="error"
      class="widget_error"
      v-html="error"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: {
    widget: {
      type: Object,
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      error: '',
      devices: {},
      series: [{
        name: "Devices",
        data: []
      }],
      options: {
        colors: ['#7774e7', '#8fc83f', '#00bbd6'],
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
            distributed: true
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          },
        },
        xaxis: {
          categories: [],
          crosshairs: {
            show: false,
            width: 1
          }
        },
      }
    }
  },
  computed: {
    ...mapState('dashboard', [
      'activeWebsite',
      'chartBaseOptions',
      'trafficData',
      'preview',
      'trafficDataError',
    ]),
    ...mapState('user', ['user']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    }
  },
  watch: {
    trafficData: {
      handler() {
        this.setData();
      },
      deep: true
    },
    trafficDataError: {
      handler() {
        if (this.trafficDataError) {
          this.error = `
                        <i class="fa fa-btn fa-exclamation-triangle"></i>
                        <span>There's a problem with your account connection. </span>
                        <a href="/website/settings/${this.activeWebsite.hash_id}">Go to settings</a>
                    `;
          this.loading = false;
        }
      }
    }
  },
  mounted() {
    if (this.trafficData?.specials?.barchart?.data) {
      this.setData();
    }
  },
  methods: {
    setData() {
      if (this.activeWebsite.has_ga_connection) {
        if (this.trafficData?.specials?.barchart?.data?.data?.data) {
          this.series[0].data = this.trafficData.specials.barchart.data.data.data;
          this.options.xaxis.categories = this.trafficData.specials.barchart.data.data.labels ?? [];
        }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.error = `<i class="fa fa-btn fa-exclamation-triangle"></i> <span>Please connect to Google Analytics.</span> ${this.user ? `<a href="/website/settings/${this.user.active_website.hash_id}">Go to settings</a>` : ''}`;
        this.loading = false;
      }
    }
  },
}
</script>

<style scoped>
tr td:not(:first-of-type) {
  text-align: center;
}
</style>
